import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { modalPrompt } from '../../../components/Modal/ModalPrompt';
import { modalSuccess } from '../../../components/Modal/ModalSuccess';
import {
  UDeleteUser,
  UGetIsUserLogin,
  UGetlistUser,
  UUpdateStatusUser,
} from '../../../usecase/user-management/user.usecase';
import useDebounce from '../../../utils/debounce';
import { defaultPagination, IPagination } from '../../../utils/pagination';
import { IParamsUser } from '../model.usermanagement';

interface IData {
  data: Array<any>;
  pagination: IPagination;
}

export const useModelUserList = () => {
  const [dataRequest, setDataRequest] = useState<IData>({
    data: [],
    pagination: defaultPagination,
  });
  const [params, setParams] = useState<IParamsUser>({
    page: 1,
    limit: 10,
    q: '',
    sort_by: 'created_at',
    order: 'desc',
    roles: 'Owner,Superuser,Outlet',
  });
  const dispatch = useDispatch();
  const debouncedParams = useDebounce(params, 300);

  async function fetchList(params: any) {
    const temp: any = await dispatch(UGetlistUser(params));
    setDataRequest({
      data: temp.data,
      pagination: temp.meta,
    });
  }

  useEffect(() => {
    fetchList(debouncedParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedParams]);

  const handleDelete = async (data: any) => {
    try {
      const isLogin: any = await dispatch(UGetIsUserLogin(data.id));
      if (isLogin) {
        return modalPrompt({
          text: 'Anda tidak dapat menghapus data, karena akun ini sedang login ke aplikasi.',
          danger: true,
          callback: () => {},
        });
      }

      await dispatch(UDeleteUser(data.id));
      fetchList(params);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = (q: string) => {
    setParams({ ...params, q, page: 1 });
  };

  const handleChangePage = (page: any) => {
    setParams({ ...params, page });
  };

  const handleFilter = (data: string) => {
    setParams({ ...params, roles: data, page: 1 });
  };

  const handleSetStatus = async (data: any, status: boolean) => {
    try {
      const payload = { is_active_account: status };
      await dispatch(UUpdateStatusUser(data.id, payload));
      modalSuccess({
        title: 'Status Data berhasil diperbaharui',
        callback: () => {},
      });
      fetchList(params);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    listData: dataRequest.data,
    pagination: dataRequest.pagination,
    handleDelete,
    params,
    handleSearch,
    handleChangePage,
    handleFilter,
    handleSetStatus,
  };
};
